import React, {MouseEvent, useEffect, useMemo, useState} from "react";
import Grid from "@mui/material/Grid";
import {ColumnDef, ColumnFiltersState} from "@tanstack/react-table";
import {useAppDispatch, useAppSelector} from "../../reducers/hooks";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {getAllElement, handleComplete, TreatmentElement} from "reducers/Treatment/TreatmentReducer";
import TablePagination from "@mui/material/TablePagination";
import {openSnackbar, SnackbarState} from "reducers/snackbar/snackbarReducer";
import {FormattedMessage, useIntl} from "react-intl";
import BasicTableCustom from "../../components/tables/BasicTableCustom";
import AlertTreatmentComplete from "../../sections/modals/treatment/AlertTreatmentComplete";
import CustomLoader from "../../components/CustomLoader";


export default function Treatment() {
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const [open, setOpen] = useState<boolean>(false)
    const {elements, currentPage, totalRows, loading, sort} = useAppSelector(state => state.treatmentElement);
    const [selectedElement, setSelectedElement] = useState<TreatmentElement | null>(null);
    const [selectCompleteElement, setSelectCompleteElement] = useState<any>();
    const [completeAlertOpen, setCompleteAlertOpen] = useState<boolean>(false);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);


    const [searchTerms, setSearchTerms] = useState({
        notes: "",
        dogId: "",
        dataExecution: "",

    });

    /*
        const filteredData = Array.isArray(elements)
            ? elements.filter((element: TreatmentElement) =>
                (element.notes?.toLowerCase() || "").includes(searchTerms.notes.toLowerCase()) &&
                (element.dogId?.toLowerCase() || "").includes(searchTerms.dogId.toLowerCase())
            )
            : [];


        // Funzione per gestire la modifica dei campi di ricerca
      const handleSearchChange = (key: string, value: string) => {
        setSearchTerms(prev => ({
            ...prev,
            [key]: value,
        }));
    };
    */
    const columns = useMemo<ColumnDef<TreatmentElement>[]>(
        () => [
            {
                header: intl.formatMessage({id: "Notes"}),
                accessorKey: 'notes',
                enableColumnFilter: false,

            },
            {
                header: intl.formatMessage({id: "Dog"}),
                accessorKey: 'microchipeCode',
                enableColumnFilter: false,

            },
            {
                header: intl.formatMessage({id: "Data Execution"}),
                accessorKey: 'executionDate',
                enableColumnFilter: false,

            },
            {
                header: intl.formatMessage({id: "Box"}),
                accessorKey: 'boxDog',
                enableColumnFilter: false,

            },
            {
                header: intl.formatMessage({id: "Shed"}),
                accessorKey: 'shedDog',
                enableColumnFilter: false,
            },

            {
                header: () => <FormattedMessage id="Actions" defaultMessage="Actions"/>,
                enableColumnFilter: false,
                accessorKey: 'Actions',
                meta: {
                    className: 'cell-right'
                },
                disableSortBy: true,
                cell: ({row}) => {
                    return (
                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0}>
                            {/*<Tooltip title="Edit">
                                <IconButton
                                    color="primary"
                                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                        e.stopPropagation();
                                        setSelectedElement(row.original);
                                        setOpen(true)
                                    }}
                                >
                                    <Edit />
                                </IconButton>
                            </Tooltip>*/}
                            <Tooltip title="Complete">
                                <IconButton
                                    color="success"
                                    onClick={(e: MouseEvent<HTMLButtonElement>) => {
                                        e.stopPropagation();
                                        setSelectCompleteElement(row.original)
                                        setCompleteAlertOpen(true)
                                    }}
                                >
                                    ✅
                                </IconButton>
                            </Tooltip>
                        </Stack>
                    );
                }
            }
        ],
        []
    );

    useEffect(() => {
        dispatch(getAllElement({
            pageableDto: {page: page, size: rowsPerPage, sort: ['name', 'asc']}
        }));
    }, [page, rowsPerPage]);

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0); // Resetta alla prima pagina
    };

    const handleChangePage = (event: MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage)
    }

    const handleModalOpen = (isOpen: boolean) => {
        setOpen(isOpen);
        if (!isOpen) setSelectedElement(null);
    };

    const checkComplete = (id: string) => dispatch(handleComplete({id, callback: checkTreatmentoComplete}))


    const {formatMessage} = useIntl();
    const getTableTitle = () => {
        return formatMessage({id: "treatmentTitle", defaultMessage: "Treatment"});
    };

    const checkTreatmentoComplete = () => {
        dispatch(getAllElement({
            pageableDto: {
                page: page,
                size: rowsPerPage,
                sort: ['dateCreated', 'desc']
            },
        }));
        openSnackbar({
            open: true,
            message: intl.formatMessage({id: 'Treatment Complete'}),
            variant: 'alert',
            alert: {
                color: 'success'
            }
        } as SnackbarState);
    };

    return (
        <>
            <CustomLoader open={loading} message="Caricamento in corso..."/>

            <Grid container>
                <Grid item xs={12}>
                    {elements && elements.length > 0 ? (
                        <>
                            <BasicTableCustom
                                columns={columns}
                                data={elements}
                                title={getTableTitle()}
                                striped
                                modalToggler={() => handleModalOpen(!open)}
                                onFilterChange={(values: ColumnFiltersState) => values}
                                manualFiltering={false}
                            />
                            <TablePagination
                                component="div"
                                count={totalRows}
                                page={page}
                                onPageChange={handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                            />
                        </>
                    ) : (
                        <div style={{padding: "20px", textAlign: "center"}}>
                            <FormattedMessage id="There are no treatments to be carried out in the next 48 hours"
                                              defaultMessage="There are no treatments to be carried out in the next 48 hours"/>
                        </div>
                    )}
                    {selectCompleteElement && (
                        <AlertTreatmentComplete
                            id={selectCompleteElement?._id}
                            title={selectCompleteElement.microchipeCode}
                            open={completeAlertOpen}
                            handleClose={() => setCompleteAlertOpen(false)}
                            onComplete={(id) => checkComplete(id)}
                        />
                    )}
                </Grid>
            </Grid>
        </>
    );
}
